import UsersGroupPage from './UsersGroupPage';
export default UsersGroupPage;
